import {HStack, StyleProps} from '@chakra-ui/react';

export const LigneProduitLayout: React.FC<
  React.PropsWithChildren<{precommande?: boolean} & StyleProps>
> = ({children, precommande = false, ...props}) => {
  return (
    <HStack
      borderBottom='1px'
      borderColor='gray.light'
      _last={{borderBottom: '0'}}
      background='white'
      width='100%'
      alignItems='stretch'
      position='relative'
      px={{base: '2', md: '20px'}}
      py={{base: '2', md: '20px'}}
      {...(precommande ? {pt: '40px'} : {})}
      {...props}
    >
      {children}
    </HStack>
  );
};
